import React from 'react';

import { Button, LbInput, Surface } from '@infoods/lifebase-ui';
import { useForm } from 'react-hook-form';
import { observer } from 'mobx-react';

import classes from './SetupLoginInfo.module.scss';
import { ReactComponent as AddNewPersonIcon } from '../../../../../shared/assets/icons/add-new-person.svg';
import { entityLoginIdService } from '../../../../services/entityLoginIdService';
import { setupEntityStore } from '../../../../stores/setupEntityStore';
import { goTo } from '../../../../../shared/utils/angularUtils';
import {
  validateLoginId,
  validateLoginIdMassage,
} from '../../../../utils/reactHookFormUtils';

type SetupLoginInfoFromValue = { loginId: string };

const SetupLoginInfo = observer(() => {
  const { control, handleSubmit } = useForm<SetupLoginInfoFromValue>({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });
  const { entityId, solutionTypeFlags } = setupEntityStore;

  if (!entityId) {
    throw new Error('Entity id is not defined');
  }

  const handleFromSubmit = handleSubmit(async ({ loginId }) => {
    await entityLoginIdService.setEntityLoginId(entityId, loginId);

    if (solutionTypeFlags.NUTRITION) {
      goTo(`/nutrition/entity-profile/${entityId}`, { replaceHistory: true });
    } else if (solutionTypeFlags.SCAN_IQ) {
      goTo(`/scan-iq/entity-profile/${entityId}`, { replaceHistory: true });
    } else {
      throw new Error('Solution type flags are not defined');
    }
  });
  return (
    <Surface className={classes.paper}>
      <AddNewPersonIcon className={classes.addNewPersonIcon} />
      <div className={classes.infoBox}>
        <h3>Almost done!</h3>
        <p>It remains to create an ID for quick login!</p>
      </div>
      <div>
        <LbInput
          control={control}
          label="Login ID"
          name="loginId"
          rules={{ required: 'Login ID is required', validate: { validateLoginId } }}
          helperText={validateLoginIdMassage}
          size="small"
        />
      </div>
      <Button variant="contained" size="medium" fullWidth onClick={handleFromSubmit}>
        Send Magic Link
      </Button>
    </Surface>
  );
});

export { SetupLoginInfo };
